import type { ReactElement } from 'react'
import type { PromptBenefit } from './promptCopy'
import styles from './PromptBenefitList.module.css'

/**
 * The prompt's ✓ benefits (Figma "Преимущества" / "Three reasons to
 * continue in app"). `inline` — bold lead-in and detail on one line (phone
 * route A); `stacked` — lead-in, then the detail below it (phone home,
 * desktop 1). `size` follows the surface: phone 14/21, desktop 18 + 16.
 */
export function PromptBenefitList({
  benefits,
  layout,
  size = 'phone',
}: {
  readonly benefits: readonly PromptBenefit[]
  readonly layout: 'inline' | 'stacked'
  readonly size?: 'phone' | 'desktop'
}): ReactElement {
  return (
    <ul className={`${styles.list} ${styles[size]}`}>
      {benefits.map(({ title, detail }) => (
        <li key={title} className={styles.item}>
          <span className={styles.check} aria-hidden="true">
            ✓
          </span>
          {layout === 'inline' ? (
            <p className={styles.inline}>
              <strong>{title}</strong> {detail}
            </p>
          ) : (
            <div className={styles.stacked}>
              <p className={styles.title}>{title}</p>
              <p className={styles.detail}>{detail}</p>
            </div>
          )}
        </li>
      ))}
    </ul>
  )
}
